<form [formGroup]="cityForm" (ngSubmit)="submitForm()" class="flex flex-col gap-6">
  <div class="rounded-2xl bg-white p-6 shadow-sm">
    <div class="grid grid-cols-2 gap-6">

      <div class="flex flex-col gap-2">
        <app-filter-input
          [label]="titleArLabel"
            [required]="true"
          [placeholder]="titleArPlaceholder"
          [value]="titleArControl().value"
          (valueChange)="onArabicChange($event)"
          [isInvalid]="titleArControl().invalid && titleArControl().touched" />

        @if (titleArControl().invalid && titleArControl().touched) {
          <span class="textError text-[12px]">
            @if (titleArControl().errors?.["required"]) {
                <span i18n="@@cityArabicRequired">The city name in Arabic is required</span>
              } @else if (titleArControl().errors?.["arabicOnly"]) {
              <span i18n="@@cityArabicOnly">The city name in Arabic must contain Arabic letters only </span>
            } @else if (titleArControl().errors?.["minlength"]) {
              <span i18n="@@cityArabicMinLength">The city name must be at least 2 characters</span>
            } @else if (titleArControl().errors?.["maxlength"]) {
              <span i18n="@@cityArabicMaxLength">The city name cannot exceed 100 characters</span>
            }
          </span>
        }
      </div>
      <div class="flex flex-col gap-2">
        <app-filter-input
          [label]="titleEnLabel"
          [placeholder]="titleEnPlaceholder"
          [value]="titleEnControl().value"
          (valueChange)="onEnglishChange($event)"
          [isInvalid]="titleEnControl().invalid && titleEnControl().touched" />

        @if (titleEnControl().invalid && titleEnControl().touched) {
          <span class="textError text-[12px]">
            @if (titleEnControl().errors?.["englishOnly"]) {
              <span i18n="@@cityEnglishOnly">The city name in English must contain English letters only</span>
            } @else if (titleEnControl().errors?.["minlength"]) {
              <span i18n="@@cityEnglishMinLength">The city name must be at least 2 characters</span>
            } @else if (titleEnControl().errors?.["maxlength"]) {
              <span i18n="@@cityEnglishMaxLength">The city name cannot exceed 100 characters</span>
            }
          </span>
        }
      </div>

      <div class="flex flex-col gap-2 col-span-1">
        <label class="text-[14px] font-medium text-gray-700">
          {{ governorateLabel }} <span class="text-red-500">*</span>
        </label>

        <div class="relative">
          <select
            formControlName="governorateId"
            [disabled]="governoratesLoading() || !!governoratesError()"
            class="w-full appearance-none rounded-lg border border-gray-300 bg-white px-4 py-2 text-[14px] outline-none focus:border-red-600 disabled:cursor-not-allowed disabled:bg-gray-100"
            [class.border-red-500]="
              governoratesError() ||
              (governorateIdControl().invalid && governorateIdControl().touched)
            "
          >
            <option [ngValue]="null" disabled>
              {{
                governoratesLoading()
                  ? (isArabic() ? 'جاري تحميل المحافظات...' : 'Loading governorates...')
                  : governoratesError()
                    ? (isArabic() ? 'تعذر تحميل المحافظات' : 'Failed to load governorates')
                    : governoratePlaceholder
              }}
            </option>

            @for (gov of governorates(); track gov.id) {
              <option [value]="gov.id">
                {{ isArabic() ? gov.titleAr : gov.titleEn }}
              </option>
            }
          </select>

          <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center px-3 text-gray-500">
            @if (governoratesLoading()) {
              <app-loading />
            } @else {
              <app-dropdown-arrow [isArabic]="isArabic()" />
            }
          </div>
        </div>

        @if (governoratesError()) {
          <span class="textError text-[12px]">
            {{ governoratesError() }}
          </span>
        }

        @if (
          !governoratesError() &&
          governorateIdControl().invalid &&
          governorateIdControl().touched
        ) {
          <span class="textError text-[12px]" i18n="@@cityGovernorateRequired">
            Please select a governorate
          </span>
        }
      </div>

    </div>

  
    <div class="mt-8 flex justify-end gap-3">
      <app-submit-button class="hover:cursor-pointer" type="secondary" (click)="$event.preventDefault(); cancel()">
        {{ cancelButton }}
      </app-submit-button>
          <app-submit-button class="hover:cursor-pointer" type="primary">
        {{ submitButton }}
      </app-submit-button>
    </div>
  


  </div>
</form>

@if (showConfirmation()) {
  <app-confirmation-dialog
    [layout]="'start'"
    [title]="confirmationTitle"
    [description]="confirmationDescription"
    [error]="errorMessage()"
    [confirmContent]="confirmButtonText()"
    [cancelContent]="cancelButton"
    (onSubmit)="confirmUpdate()"
    (onCancel)="closeConfirmation()" />
}

@if (successMessage()) {
  <app-successful-notification type="success" [title]="successMessage()!" />
}